
export const MINUTE = 60
export const HOUR = MINUTE * 60;
export const DAY = 24 * HOUR;

export class DashboardUtils {

    static getTimeNow() {
        return new Date().getTime();
    }

    static getTime(daysAgo: number = 0) {
       const offset = (DAY * daysAgo) * 1000
       const time_now = this.getTimeNow() - offset;
       return time_now - offset;
    }

    static getSeconds(daysAgo: number = 0) {
        return Math.floor(this.getTime(daysAgo) / 1000);
    }
    static  getWhen(seconds: number, daysAgo: string, hoursAgo: string, minsAgo: string, secsAgo: string): string {
      seconds = Math.max(0, Math.floor(seconds));  // prevent negative values
      const days = Math.floor(seconds / DAY);
      const hours = Math.floor(seconds / HOUR);
      const mins = Math.floor(seconds / MINUTE);

      if (days > 0) return `${days} ${daysAgo}`;
      if (hours > 0) return `${hours} ${hoursAgo}`;
      if (mins > 0) return `${mins} ${minsAgo}`;
      return `${seconds} ${secsAgo}`;
    }
}
